import { isWeChatWebView } from './wechat-media-unlock';

export const hasUsableCameraVideoTrack = (stream: MediaStream | null | undefined): boolean => {
  const track = stream?.getVideoTracks?.()[0];
  return Boolean(track && track.readyState === 'live');
};

/** 浏览器 getUserMedia 摄像头轨。上传视频 / canvas 预览即使带 deviceId 也不算。 */
export const isRtcCameraGumStream = (stream: MediaStream | null | undefined): boolean => {
  const track = stream?.getVideoTracks?.()[0];
  if (!track || track.readyState === 'ended') {
    return false;
  }
  const settings = typeof track.getSettings === 'function' ? track.getSettings() : undefined;
  if (!settings || settings.displaySurface) {
    return false;
  }
  return settings.facingMode === 'user' || settings.facingMode === 'environment';
};

/**
 * 微信小程序 / 内置浏览器切后台会直接停掉摄像头。
 * 轨道可能仍显示 live，预览却已经是黑的，回前台必须重新 getUserMedia。
 */
export const shouldReacquireCameraOnForeground = (
  stream: MediaStream | null | undefined,
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): boolean => isWeChatWebView(userAgent) || !hasUsableCameraVideoTrack(stream);

export const subscribePageForeground = (onForeground: () => void, dedupeMs = 1_000): (() => void) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return () => {};
  }

  let lastForegroundAt = Number.NEGATIVE_INFINITY;
  const handle = () => {
    if (document.visibilityState !== 'visible') {
      return;
    }
    const now = Date.now();
    if (now - lastForegroundAt <= dedupeMs) {
      return;
    }
    lastForegroundAt = now;
    onForeground();
  };

  document.addEventListener('visibilitychange', handle);
  window.addEventListener('focus', handle);
  return () => {
    document.removeEventListener('visibilitychange', handle);
    window.removeEventListener('focus', handle);
  };
};
